/**
 * Input validity checks — verbatim from v1 (research/03 §3, §10, §15.14/15.15;
 * REQ-ELEM-6/7). Preserves the duplicated `inValidCount == 1 &&
 * inValidCount == 1` condition, the contradictory lookup sub-clause, the
 * `nextSibling.remove()` of WHATEVER the next sibling is, and the min-length
 * label wording. CheckTextInputValidity does NOT call UpdatePrice on failure.
 *
 * jQuery split (research/01 Q1): bare $ = BUNDLED jQuery;
 * all jQuery is the BUNDLED copy (DIV-004).
 */
import $ from "jquery";
import { appState } from "../state/app-state";
import { UpdatePrice } from "../pricing";
import { t } from "../i18n/translate";
import { dirAttr } from "./base";

export function CheckNumberInputValidity(element: any, elemMaxDecimal?: any): boolean {
  let alertMessage = appState.cpc_configData.alertMessageNumberInput;
  let inValidCount = 0;
  let inValidProp = "";
  let isValid = true;
  var inputValue = element.value;
  var decimalPlaces = (inputValue.split(".")[1] || "").length;
  if (!element.validity.valid) {
    for (var key in element.validity) {
      if (element.validity[key]) {
        inValidCount++;
        inValidProp = key.toLowerCase();
      }
    }
  }
  //if(inValidCount>1 || (inValidCount == 1 && inValidProp!='stepmismatch'))
  //if(inValidCount>1 || (inValidCount == 1))
  if (
    inValidCount > 1 ||
    (element.step == 1 && inValidProp == "stepmismatch") ||
    decimalPlaces > elemMaxDecimal ||
    (inValidCount == 1 &&
      inValidCount == 1 &&
      inValidProp != "stepmismatch" &&
      ($(element).data("lookup") == null ||
        ($(element).data("lookup") == undefined &&
          $(element).data("lookup") != true)))
  )
    isValid = false;

  if (element.value.length == 0 || !isValid) {
    element.setAttribute("style", "border:1px solid red !important;");
    element.value = element.min || 0;
    if (element.nextSibling == null) {
      if (
        alertMessage
          .replace("{input_range_min}", "")
          .replace("{input_range_max}", "")
          .trim().length > 0
      ) {
        let min = element.getAttribute("min");
        let max = element.getAttribute("max");
        // Translations v1: the merchant's range message is swapped BEFORE the
        // placeholders are filled, so a translation must keep the tokens.
        const rangeSource = alertMessage;
        alertMessage = t(alertMessage)
          .replace("{input_range_min}", min)
          .replace("{input_range_max}", max)
          .trim();
        element.insertAdjacentHTML(
          "afterend",
          "<label style='color:red;'" + dirAttr(rangeSource) + ">" + alertMessage + "</label>",
        );
      } else
        element.insertAdjacentHTML(
          "afterend",
          "<label style='color:red;'" + dirAttr("Value out of range") + ">" + t("Value out of range") + "</label>",
        );
    }
    UpdatePrice();
    return false;
  }

  element.style.setProperty("border", "");

  if (element.nextSibling != null) element.nextSibling.remove();

  // Step interval snapping
  var stepInterval = parseFloat(element.dataset.stepinterval);
  if (!isNaN(stepInterval) && stepInterval > 0) {
    var value = parseFloat(element.value);
    var minValue = parseFloat(element.min) || 0;
    var maxValue = parseFloat(element.max) || 100000;
    var snapped = Math.round(value / stepInterval) * stepInterval;
    // respect min/max after snapping
    snapped = Math.max(snapped, minValue);
    snapped = Math.min(snapped, maxValue);
    // Re-round to maxdecimals to eliminate IEEE-754 float drift
    // e.g. Math.round(3.8 / 0.1) * 0.1 === 3.8000000000000003
    var maxDec = elemMaxDecimal != null ? Number(elemMaxDecimal) : parseInt(element.dataset.maxdecimals, 10);
    if (!isNaN(maxDec)) snapped = parseFloat(snapped.toFixed(maxDec));
    element.value = snapped;
  }

  UpdatePrice();
  return true;
}

export function CheckTextInputValidity(element: any): boolean {
  var minLength = parseInt(element.getAttribute("minlength")) || 0;
  var maxLength = parseInt(element.getAttribute("maxlength")) || 100000;
  var value = element.value;
  var length = value.length;

  // Remove previous error label if present
  var nextSibling = element.nextElementSibling;
  if (nextSibling != null && nextSibling.classList.contains("cpc-text-error")) {
    nextSibling.remove();
  }

  if (minLength > 0 && length < minLength) {
    element.setAttribute("style", "border:1px solid red !important;");
    $(element).addClass("error-border");
    // Translations v1: translated as one phrase with its {count} token, so the
    // word order can differ per language; untranslated output is unchanged.
    element.insertAdjacentHTML(
      "afterend",
      "<label class='cpc-text-error' style='color:red; display:block; margin-top:4px;'" +
        dirAttr("Minimum {count} characters required") +
        ">" +
        t("Minimum {count} characters required").replace("{count}", String(minLength)) +
        "</label>",
    );
    return false;
  }

  element.style.setProperty("border", "");
  $(element).removeClass("error-border");
  UpdatePrice();
  return true;
}
